import {MenuRadio} from "./Menu";
import MainModule from "../../../Main.module.scss";
import {FrontWebRadioDetailModel, FrontWebSimilarRadiosModel} from "../../../../../generated";
import H2Header from "./H2Header";
import routes from "../../../../../utils/routes";
import {
    Advertisement,
    Advertisement as Adv,
    HideIfSizeAdvertisement
} from "../../../../../components/Advertisement/Advertisement";
import {RadioBoxList} from "../../../../../components/List/Radio/RadioBoxList";
import {PageHeader} from "../../../../../components/PageHeader";

import nextsvg from "../../../../../static/next1.svg";
import {useDebug} from "../../../../../contexts/useDebug";

type Props = {
    children: React.ReactNode,
    radio: FrontWebRadioDetailModel,
    activeUrl: string
    similars?: FrontWebSimilarRadiosModel | null,
    id?: string
}

export const Main = ({
                         id, children, activeUrl, radio, similars
                     }: Props) => {
    const hasId = {
        id: id
    }
    if (!id)
        delete hasId.id;

    // const { advertisementDebug } = useDebug();

    return <main {...hasId} className={`main mb-48px`}>
        <PageHeader/>
        <MenuRadio radio={radio} activeUrl={activeUrl}/>
        <HideIfSizeAdvertisement winWidthMaxSize={799}>
            <Advertisement id={"adform_square"}/>
        </HideIfSizeAdvertisement>
        <div className={`d-flex`}>
            <div className={`${MainModule.mainFill} flex-fill  `}>
                <hr className={"mt-0"}/>
                {children}
            </div>
            <div className={`${MainModule.ParentAdvertisement} flex-grow-0 flex-shrink-0`}>

                <HideIfSizeAdvertisement winWidthMinSize={800}>
                    <Adv id="adform_square" className={`${MainModule.Advertisement} float-right`} style={{
                        width: "300px",
                        minHeight: "0px",
                        maxHeight: "600px",
                    }}/>
                </HideIfSizeAdvertisement>

                {similars ? <>
                    <H2Header small={true}><a href={routes.radio_podobnaradia(radio.slug)}>{similars.name}&nbsp;<img
                        src={nextsvg} className={"align-self-center"} alt={""}/></a></H2Header>
                    <RadioBoxList items={similars.radios.slice(0, 2)}/>
                </> : false}
                <HideIfSizeAdvertisement winWidthMinSize={800}>
                    <Adv id="adform_square2" className={`${MainModule.Advertisement} float-right`} style={{
                        width: "300px",
                        minHeight: "0px",
                        maxHeight: "600px",

                    }}/></HideIfSizeAdvertisement>
            </div>
        </div>

        <HideIfSizeAdvertisement winWidthMaxSize={799}>
            <Advertisement id={"adform_square2"}/>
        </HideIfSizeAdvertisement>
    </main>
}